import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Modal } from 'semantic-ui-react'

import { systemMessageCanceled, systemMessageShow } from '../../actions/SystemMessageActions'

import './SystemMessage.css'

class SystemMessage extends Component {
  constructor(props) {
    super(props)
    this.state = {}

    this.close = this.close.bind(this)
    this.onOptionClick = this.onOptionClick.bind(this)
  }

  close() {
    this.props.systemMessageCanceled()
    this.props.onClose()
  }

  onOptionClick(event) {
    event.preventDefault()
    if (!this.state.updating && this.state.emailStatus === 1 && this.state.passStatus === 1) {
      this.setState({
        updating: true,
      })
      this.props.systemMessageShow(this.state.email, this.state.pass)
    }
  }

  render() {
    const { message } = this.props

    const options = message.options.map((opt) => <Button key={Math.random()} {...opt} />)

    return (
      <Modal
        className="ModalSystemMessage"
        closeIcon="close"
        dimmer
        onClose={this.close}
        open={message.show}
        size="small"
      >
        <Modal.Header>{message.title || ''}</Modal.Header>
        <Modal.Content>{message.msg}</Modal.Content>
        <Modal.Actions>{options}</Modal.Actions>
      </Modal>
    )
  }
}

SystemMessage.propTypes = {
  message: PropTypes.shape({
    msg: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    options: PropTypes.array.isRequired,
    show: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  }).isRequired,
  onClose: PropTypes.func,
  systemMessageCanceled: PropTypes.func.isRequired,
  systemMessageShow: PropTypes.func.isRequired,
}

SystemMessage.defaultProps = {
  onClose: Function.prototype,
}

function mapStateToProps(_state, props) {
  return {
    initialValues: props.obj, // pull initial values from account reducer
  }
}

export default connect(mapStateToProps, {
  systemMessageCanceled,
  systemMessageShow,
})(SystemMessage)
